import { createGlobalStyle, css } from 'styled-components';
import Font from '../Font';
import reset from '../Reset';
import { IEnvironmentTypes } from '../Font/Font.config';

const GlobalStyle = (environment: IEnvironmentTypes, additionalStyles: ReturnType<typeof css>) => {
  const font = Font(environment);
  return createGlobalStyle`
    ${font}
    ${reset}
    ${additionalStyles}
  `;
};

export default GlobalStyle;
